/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The MonitoringControllerDtoGearNftListGearNftData model module.
 * @module model/MonitoringControllerDtoGearNftListGearNftData
 * @version 1.0
 */
class MonitoringControllerDtoGearNftListGearNftData {
    /**
     * Constructs a new <code>MonitoringControllerDtoGearNftListGearNftData</code>.
     * @alias module:model/MonitoringControllerDtoGearNftListGearNftData
     */
    constructor() { 
        
        MonitoringControllerDtoGearNftListGearNftData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>MonitoringControllerDtoGearNftListGearNftData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/MonitoringControllerDtoGearNftListGearNftData} obj Optional instance to populate.
     * @return {module:model/MonitoringControllerDtoGearNftListGearNftData} The populated <code>MonitoringControllerDtoGearNftListGearNftData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new MonitoringControllerDtoGearNftListGearNftData();

            if (data.hasOwnProperty('nftUid')) {
                obj['nftUid'] = ApiClient.convertToType(data['nftUid'], 'Number');
            }
            if (data.hasOwnProperty('grade')) {
                obj['grade'] = ApiClient.convertToType(data['grade'], 'Number');
            }
            if (data.hasOwnProperty('accountNo')) {
                obj['accountNo'] = ApiClient.convertToType(data['accountNo'], 'Number');
            }
            if (data.hasOwnProperty('active')) {
                obj['active'] = ApiClient.convertToType(data['active'], 'Boolean');
            }
            if (data.hasOwnProperty('activeAt')) {
                obj['activeAt'] = ApiClient.convertToType(data['activeAt'], 'Date');
            }
            if (data.hasOwnProperty('expireAt')) {
                obj['expireAt'] = ApiClient.convertToType(data['expireAt'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>MonitoringControllerDtoGearNftListGearNftData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>MonitoringControllerDtoGearNftListGearNftData</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Number} nftUid
 */
MonitoringControllerDtoGearNftListGearNftData.prototype['nftUid'] = undefined;

/**
 * @member {Number} grade
 */
MonitoringControllerDtoGearNftListGearNftData.prototype['grade'] = undefined;

/**
 * @member {Number} accountNo
 */
MonitoringControllerDtoGearNftListGearNftData.prototype['accountNo'] = undefined;

/**
 * @member {Boolean} active
 */
MonitoringControllerDtoGearNftListGearNftData.prototype['active'] = undefined;

/**
 * @member {Date} activeAt
 */
MonitoringControllerDtoGearNftListGearNftData.prototype['activeAt'] = undefined;

/**
 * @member {Date} expireAt
 */
MonitoringControllerDtoGearNftListGearNftData.prototype['expireAt'] = undefined;






export default MonitoringControllerDtoGearNftListGearNftData;

